/// <reference types="@backstage/cli/asset-types" />
import ReactDOM from 'react-dom/client';
import App from './App';
import { applyDefaultTheme } from './theme';
import '@backstage/ui/css/styles.css';

applyDefaultTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
